import React from 'react'
import GenericPullAndPushToolView from '../GenericPullAndPushToolView'
import PrivadoConfigListing from './PrivadoConfigListing'
import PrivadoCredentialsForm from './PrivadoCredentialsForm'

export default function PrivadoPullAndPushView(props) {
    return (
        <GenericPullAndPushToolView 
            {...props}
            PullCredentialForm={PrivadoCredentialsForm}
            PullConfigListingView={PrivadoConfigListing}
            RunOnDemandButtonText={'Sync tool applications'}
        />
    )
}